import {
  artistArrears,
  arrearsDayId,
  ARREARS_GRACE_MIN,
  ARREARS_LOOKBACK_DAYS,
  type ArrearsArtistLite,
} from '@/domain/artistArrears';
import type { OpsUnpaidArtistItem } from '@/domain/opsWorklist';
import type { Booking, PayoutRecord, SalePayment, StudioId } from '@/domain/types';

// ---------------------------------------------------------------------------
// Unpaid artists on the Ops desk (W5 mh, 14ym9bv75mh — DECIDED). Built from the
// ops-view data (bookings + artists + payoutRecords), never the store, so it
// works on every day in the lookback, not only "today".
//
// The rule itself lives in `artistArrears` — the one source the Day sheet's
// "Still owed to artists" panel reads too (W4-RFIX), so the two screens never
// disagree. This only maps each owed studio-day onto an Ops row.
// ---------------------------------------------------------------------------

export const UNPAID_ARTIST_GRACE_MIN = ARREARS_GRACE_MIN;
export const UNPAID_ARTIST_LOOKBACK_DAYS = ARREARS_LOOKBACK_DAYS;

/** The artist fields the derivation reads (a store / view Artist is assignable). */
export type UnpaidArtistLite = ArrearsArtistLite;

export interface OpsUnpaidArtistsArgs {
  nowIso: string;
  /** Studio scope; [] = every studio. */
  studioIds: StudioId[];
  bookings: Record<string, Booking>;
  artists: Record<string, UnpaidArtistLite>;
  payoutRecords: Record<string, PayoutRecord>;
  /** B1: the sales the owed amounts are priced from (ops view). */
  salePayments?: Record<string, SalePayment>;
}

/** Stable row id for an artist + studio-day (dayKey = YYYY-MM-DD, studio-local). */
export const unpaidArtistId = arrearsDayId;

export function opsUnpaidArtists(args: OpsUnpaidArtistsArgs): OpsUnpaidArtistItem[] {
  return artistArrears(args).map((d) => ({
    id: d.id,
    kind: 'unpaid-artist',
    studioId: d.studioId,
    artistId: d.artistId,
    artistName: d.artistName,
    amountAud: d.amountAud,
    dayIso: d.dayIso,
  }));
}
